import React from 'react'
import { Avatar } from '@mui/material'

interface ProfileImageProps {
  name: string
  image: string | null
  size?: number
}

const getInitials = (name: string): string => {
  const cleanName = name.replace(/[^a-zA-Z\s]/g, '').trim()
  const namesArray = cleanName.split(' ').filter(Boolean)
  const initials = namesArray.map((name) => name.charAt(0).toUpperCase())
  return initials.join('').slice(0, 3)
}

export const ProfileImage: React.FC<ProfileImageProps> = ({ name, image, size = 40 }) => {
  const styles = {
    container: {
      width: size,
      height: size,
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#e0e0e0',
    },
    img: {
      width: size,
      height: size,
      objectFit: 'contain' as const,
    },
    initialsSpan: {
      fontSize: size * 0.4,
      fontWeight: 500,
      color: '#424242',
      size: size,
    },
  }

  return (
    <div style={styles.container}>
      {image ? (
        <img src={image} alt={name || ''} style={styles.img} />
      ) : name === '' ? (
        <Avatar
          sx={{
            width: size,
            height: size,
          }}
          alt={name}
        />
      ) : (
        <span style={styles.initialsSpan}>{getInitials(name)}</span>
      )}
    </div>
  )
}

export default ProfileImage
